import React from 'react';

import { addClient } from '../../../../data/serviceClients';

import { InputRow } from '../../../../helpers/uiComponents/InputRow';
import { ActionTabs } from '../../../../helpers/uiComponents/ActionTabs';

import { managerList, packageList, socialList, statusList, semManagerList, seoManagerList } from '../../../../helpers/uiFunctions/uiHelpers'
import AccordianTitle from '../../../../helpers/uiComponents/Accordian';
import { hideMessage, showMessage } from '../../../../helpers/uiFunctions/uiActions';

export class AccountInformation extends React.Component {
	constructor(props) {
		super(props);
		// console.log(props);
		this.save = this.save.bind(this);
		this.handleUpdate = this.handleUpdate.bind(this);
	}

	handleUpdate(e) {
		var key = e.target.name;
		var value = e.target.value;
		var subArr = null;

		if (key.includes(".")) {
			subArr = key.split('.')[0];
			key = key.split('.')[1];
		}

		var type = e.target.type;
		if (type === "checkbox") {
			value = e.target.checked
		}
		var updateClient = this.props.updateClient
        updateClient(key, value, subArr);
	}
	save() {
		showMessage("Saving account...");
		var client = this.props.currentClient;
		delete client.transactions;
		addClient(this.props.currentClient).then(data => {
			hideMessage(data.success);
			var getClient = this.props.getClient;
			getClient(this.props.currentClient.clientCode);
		});
	}

	render() {
		const currentClient = this.props.currentClient;
		
		return (
			<div className="input-group">
				<AccordianTitle title={"Account Information"} />
				<div className="accordian-body">
					<ActionTabs
						id={"account"}
						handleSave={this.save}
					/>
					{(currentClient) && (
						<div id="general-inputs" className="inputs">
							<React.Fragment key={currentClient.clientCode}>
								<InputRow onChange={this.handleUpdate} label="Client Name (DBA)" type="text" value={currentClient.name} property="name" 
								description={""}/>
								<InputRow onChange={this.handleUpdate} label="Tax Name (W9)" type="text" value={currentClient.w9Name} property="w9Name" />
								<InputRow onChange={this.handleUpdate} label="Nickname (CDE)" type="text" value={currentClient.nickname} property="nickname" 
								description={""}/>
								<InputRow label="Client Code" type="text" value={currentClient.clientCode} property="clientCode" disabled />
								<InputRow
									onChange={this.handleUpdate}
									label="Client Status"
									type="select"
									value={currentClient.status}
									property="status"
									id="status"
									options={statusList}
								/>
								<InputRow
									onChange={this.handleUpdate}
									label="Account Manager"
									type="select"
									value={currentClient.manager}
									property="manager"
									id="manager"
									options={managerList}
									description={""}
								/>
								<InputRow
									onChange={this.handleUpdate}
									label="Social Media Manager"
									type="select"
									value={currentClient.socialManager}
									property="socialManager"
									id="socialManager"
									options={socialList}  
									description={""}
								/>
								<InputRow
									onChange={this.handleUpdate}
									label="SEM Manager"
									type="select"
									value={currentClient.semManager}
									property="semManager"
									id="semManager"
									options={semManagerList}
									description={""}  
								/>
								<InputRow
									onChange={this.handleUpdate}
									label="SEO Manager"
									type="select"
									value={currentClient.seoManager}
									property="seoManager"
									id="seoManager"
									options={seoManagerList}  
									description={""}
								/>
								{/* <InputRow
									onChange={this.handleUpdate}
									label="Client Type"
									type="select"
									value={currentClient.type}
									property="type"
									id="type"
									options={[
										{"name": "Client", "value": "client"}
									]}
								/> */}

								<InputRow onChange={this.handleUpdate} label="Shaw Account Number" type="text" value={currentClient.shawAccount} property="shawAccount" description="Main account number assigned to a retailer by shaw." />
								<InputRow onChange={this.handleUpdate} label="Mohawk Account Number" type="text" value={currentClient.mohawkAccount} property="mohawkAccount" description="Main account number assigned to a retailer by Mohawk.  Ensure the account number is 10 digits long, starting with '0010'" />

								<h4>Velocity</h4>
									<InputRow onChange={this.handleUpdate} label="Velocity Account?" type="checkbox" value={currentClient.velocity} property="velocity"/>
									{(currentClient.velocity) && (
										<React.Fragment>
											<InputRow onChange={this.handleUpdate} label="Velocity Contract Complete" type="checkbox" value={currentClient.contractComplete} property="contractComplete" />
											<InputRow label="Velocity Contract Signature" type="text" value={currentClient.contractSignature} property="contractSignature" description="signature gathered from onboarding portal" disabled />
											<InputRow
												onChange={this.handleUpdate}
												label="Service Package"
												type="select"
												value={currentClient.servicePackage}
												property="servicePackage"
												id="servicePackage"
												options={packageList}
												description={""}
											/>
											<InputRow onChange={this.handleUpdate} label="Opt In to Use Shaw BDF Funds?" type="checkbox" value={currentClient.shawBdf} property="shawBdf" />
										</React.Fragment>
									)}
									
			
								<h4>Advertising</h4>
									<InputRow
										onChange={this.handleUpdate}
										label="Advertising Package"
										type="select"
										value={currentClient.adPackage}
										property="adPackage"
										id="adPackage"
										options={[
											{ "name": "$250/Month", "value": "250"
											}, { "name": "$500/Month", "value": "500"
											}, { "name": "$1,000+/Month", "value": "1000" }
										]}
									/>
			
								<h4>Rug Shop</h4>
									<InputRow onChange={this.handleUpdate} label="Rug Shop Affiliate Code" type="text" value={currentClient.rugAffiliateCode} property="rugAffiliateCode" />
			
								<h4>Flooring You Well</h4>
									<InputRow onChange={this.handleUpdate} label="Flooring You Well Account?" type="checkbox" value={currentClient.fyw} property="fyw" 
									description={""}/>

<h4>Mohawk Programs</h4>
								<InputRow onChange={this.handleUpdate} label="Omnify" type="checkbox" value={currentClient.omnify} property="omnify"/>

								<InputRow onChange={this.handleUpdate} label="Edge Local Advertising (ELA)" type="checkbox" value={currentClient.ela} property="ela"/>
								
							</React.Fragment>
						</div>
					)}
				</div>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/component_client/components/ClientProfile/ProfileComponents/AccountInformation.js